<template>
  <vs-popup
    :title="'Activation event: ' + (event ? event.title : '')"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="activation-event-details-popup"
  >
    <div class="activation-event-details-popup-content" v-if="event">
      <vs-row> Venue: {{ venueName }} </vs-row>
      <vs-row v-if="event.description" class="mt-2"> Description: {{ event.description }} </vs-row>
      <vs-row v-if="event.userId" class="mt-2"> User: {{ getUserName(event.userId) }} </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      venueName: "",
      event: undefined,
      showThisPopup: false
    };
  },
  computed: {
    ...mapGetters({
      user: "users/user",
    }),
  },
  methods: {
    show(venueName, event) {
      this.venueName = venueName;
      this.event = event;
      this.showThisPopup = true;
    },
    handlePopupClose() {
      this.venueName = "";
      this.event = undefined;
      this.showThisPopup = false;
    },
    getUserName(userId) {
      const userObject = this.user(userId);
      if(!userObject) return 'Unknown user';
      return `${userObject.firstName} ${userObject.lastName}`;
    }
  },
};
</script>

<style lang="scss" scoped>
.activation-event-details-popup::v-deep .vs-popup {
  width: 600px;

  .vs-popup--content {
    overflow: hidden;

    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
